export const UPDATE_QUOTATION_DETAIL = "UPDATE_QUOTATION_DETAIL";
export const IS_SAVE_ONPROGESS = "IS_SAVE_ONPROGESS";
export const ON_CREATE_QUOTATION = "ON_CREATE_QUOTATION";
export const RESET_QUOTATION_STATE = "RESET_QUOTATION_STATE";
export const SET_NAVIGATION_TAB = "SET_NAVIGATION_TAB";
export const SET_BUSINESS_TYPE = "SET_BUSINESS_TYPE";